import {HttpExclude, Request} from '@simpli/serialized-request'
import {PageCollection} from '@simpli/resource-collection'
import {User} from '@/model/resource/User'

@HttpExclude()
export class UserCollection extends PageCollection<User> {
  resource?: IUserCollectionResourcesHolder

  constructor() {
    super(User)
  }

  queryAsPage() {
    return this.listUser()
  }

  async listUser() {
    return await Request.get(`/client/user`, {params: this.params})
      .name('listUser')
      .as(this)
      .getResponse()
  }

  async listExportUser() {
    return await Request.get(`/client/user/export`, {params: this.params})
      .name('listExportUser')
      .as(this)
      .getResponse()
  }
}

export interface IUserCollectionResourcesHolder {}
